import PropTypes from "prop-types";
import React, { useEffect, useRef, useCallback } from "react";
//Import Icons
import FeatherIcon from "feather-icons-react";
//Import images
import giftBox from "../../assets/images/giftbox.png";
// //Import Scrollbar
import SimpleBar from "simplebar-react";
// MetisMenu
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
import { getPolicyUser, getStorageUser } from "../helpers/api_helper";

const SidebarContent = (props) => {
  const policy = getPolicyUser();
  const user = getStorageUser();
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">Inicio </li>
            <li>
              <Link to="/dashboard" className="">
                <FeatherIcon icon="home" />
                <span>Inicio</span>
              </Link>
            </li>
            {[3, 4].includes(user.profile_id) && (
              <li>
                <Link to="/instalaciones" className="">
                  <FeatherIcon icon="tool" />
                  <span>Instalaciones</span>
                </Link>
              </li>
            )}
            {[3, 4].includes(user.profile_id) && (
              <>
                <li className="">
                  <Link to="/#" className="has-arrow">
                    <span className="fa fa-clipboard me-3 d-inline-block" style={{width: '12px', paddingLeft: '8px'}}></span>
                    <span>{props.t("Reportes")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/reporte/instalaciones" className="">
                        <FeatherIcon icon="tool" />
                        Instalaciones
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            )}
            {[1, 2, 3].includes(user.profile_id) && (
              <>
                <li>
                  <Link to="/#" className="has-arrow">
                    <FeatherIcon icon="grid" />
                    <span>Catálogos</span>
                  </Link>
                  <ul className="sub-menu">
                    {[1].includes(user.profile_id) && (
                      <li>
                        <Link to="/resellers" className="">
                          <FeatherIcon icon="users" />
                          <span>Revendedores</span>
                        </Link>
                      </li>
                    )}
                    {[1].includes(user.profile_id) && (
                      <li>
                        <Link to="/profiles" className="">
                          <span className="fas fa-user-shield me-2"></span>
                          Perfiles
                        </Link>
                      </li>
                    )}
                    {[3].includes(user.profile_id) && (
                      <li>
                        <Link to="/users" className="">
                          <FeatherIcon icon="users" />
                          <span>Usuarios</span>
                        </Link>
                      </li>
                    )}
                    {[2].includes(user.profile_id) && (
                      <li>
                        <Link to="/companies">
                          <span className="fas fa-building me-2"></span>
                          <span>Empresas</span>
                        </Link>
                      </li>
                    )}
                    {[2,3].includes(user.profile_id) && (
                      <li>
                        <Link to="/configuration">
                          <span className="fas fa-tools me-2"></span>
                          <span>Configuraciones</span>
                        </Link>
                      </li>
                    )}
                    {[1].includes(user.profile_id) && (
                      <li>
                        <Link to="/instalacion_tipos" className="">
                          <span className="fas fa-list-ol me-2"></span>
                          Tipos de instalacion
                        </Link>
                      </li>
                    )}
                    {[1].includes(user.profile_id) && (
                      <li>
                        <Link to="/condiciones" className="">
                          <span className="fas fa-check-square me-2"></span>
                          Condiciones
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
